export default __webpack_public_path__ + "static/media/Emilian.9a451367.png";